import { isInternalUser } from "common/MetaActions";

const validFileTypes = `"csv", "docx", "jpg", "ods", "odt", "pcSKOGZ", "pdf", "png",
"pptx", "rtf", "se", "si", "txt", "xlsx", "xml", "agi", "zip",
"kis", "xml", "in", "002", "html", "log", "lon", "twt", "xlm", "pax",
"wli", "bf", "bck", "msg", "eskd", "pbu", "xbk", "001", "HPZ",
"jpeg", "xlt", "xls", "hts", "bks", "tlu", "json", "dat", "xltx", "paxml"`;

const validInternalFileTypes = `, "doc", "docm", "xlsm"`;

export const uploadFileErrorMessage = {
  FILE_CANNOT_BE_EMPTY: {
    title: "Filstorlek",
    message:
      "Filen ser ut att vara tom och kan inte laddas upp. Kontrollera filen och försök igen."
  },
  FILE_TOO_LARGE: {
    title: "Filstorlek",
    message: "Filen är för stor för att laddas upp. Max storlek är 250MB."
  },
  FILE_TOO_LARGE_DELIVERY: {
    title: "Filstorlek",
    message: "Filen är för stor för att laddas upp. Max storlek är 4.5MB."
  },
  INVALID_FILE_TYPE: {
    title: "Ogiltig filtyp",
    message: `Giltiga typer är: ${validFileTypes} ${isInternalUser() ? validInternalFileTypes : ""}`
  }
};
